#import "@/apollo/fragments/MasterTemplate.gql"

mutation ResizeMasterTemplate(
    $masterTemplateId: ID!
    $campaignId: ID
    $width: Float!
    $height: Float!
    $initiate: Boolean
) {
    resizeMasterTemplate(
        masterTemplateId: $masterTemplateId
        campaignId: $campaignId
        width: $width
        height: $height
        initiate: $initiate
    ) {
        masterTemplate {
            ...MasterTemplate
        }
        resource {
            resourceId
            status
            percentage
        }
    }
}
